var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { deriveSize } from '@lendi-ui/utils';
import { select } from '@lendi/ui/Theme';
import { mt, pb, pt } from '@lendi-ui/spacing';
import { body } from '@lendi-ui/typography';
export var MessageListWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    return props.isExperiment
        ? "\n      padding-left: 20px;\n    "
        : "\n      height: 100%;\n      ".concat(mt('sm'), ";\n    ");
});
export var StyleWelcome = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  text-align: center;\n  ", ";\n  ", ";\n  font-size: ", ";\n  font-family: ", ";\n"], ["\n  ", ";\n  text-align: center;\n  ", ";\n  ", ";\n  font-size: ", ";\n  font-family: ", ";\n"])), body({ size: 'sm', color: 'shade.700' }), pt('md'), pb('xxs'), deriveSize(0.875), select('typography.body.fontFamily'));
var templateObject_1, templateObject_2;
//# sourceMappingURL=style.js.map